import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-main-routes',
  templateUrl: './add-main-routes.component.html',
  styleUrls: ['./add-main-routes.component.scss']
})
export class AddMainRoutesComponent implements OnInit {

  routesForm:FormGroup
  routesFormSubmitted:boolean=false;
  constructor(private formBuilder: FormBuilder,
              public toastr: ToastrService,
              public apiService:ApiService,
              private route:Router) { }

  ngOnInit() {
    
    this.routesForm=this.formBuilder.group({
      path: ['', Validators.required],
      title: ['', Validators.required],
    })
  }
  get rf() {
    return this.routesForm.controls;
  }
  submit(){
    let body={
    
        path: this.routesForm.value.path,
        title: this.routesForm.value.title,
        isShow: 'admin',
        icon: 'ft-home',
        classes: 'dropdown nav-item has-sub',
        isExternalLink: false,
        submenu: [],
        asignfor: []
    }
    this.apiService.mainMenuCreate(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log(body)
      }
      else{
        this.toastr.error(res.error)
      }
    })
  } 
  back(){}
}
